import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.243 16.182c1.025-1.026.194-3.519-1.856-5.569S8.843 7.732 7.818 8.757s-.194 3.518 1.856 5.568 4.544 2.882 5.569 1.857"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.4 9.7.888 21.121a1.5 1.5 0 0 0 1.991 1.991L14.3 16.605M12.857.75c.211 1.89.03 3.803-.531 5.62m4.243-4.242-.53 2.651m7.211 6.364a13.8 13.8 0 0 0-5.62.531m4.242-4.243-2.651.53"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M8.083 5.154a.375.375 0 0 1 0-.75m0 .75a.375.375 0 1 0 0-.75m7.425 3.933a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m4.242-3.493a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m0 11.356a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const entertainmentPartyPopperConfetti = { render };
export {
  entertainmentPartyPopperConfetti as default,
  render
};
//# sourceMappingURL=entertainment-party-popper-confetti.svg.js.map
